import { FC, ReactNode } from 'react';

import { ModalHostProvider } from '@shared/lib/modal';

import { appModalHost } from './appModalHost';

export const AppModalHostProvider: FC<{ children?: ReactNode }> = ({ children }) => (
  <ModalHostProvider host={appModalHost}>{children}</ModalHostProvider>
);
